import React, { useMemo } from 'react';
import { SelectMenu } from '@scale/scaleui';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { ExclusiveWorkerExpirationAction } from '@scale/shared-types';

interface ExclusiveWorkerExpirationActionBuilderProps {
  name: string;
  existingValue?: ExclusiveWorkerExpirationAction;
  updateProperty: (value: ExclusiveWorkerExpirationAction) => void;
  required?: boolean;
  hint?: string;
}

const labelMap: Record<ExclusiveWorkerExpirationAction, string> = {
  [ExclusiveWorkerExpirationAction.MoveToL11]: 'Move to L11 (default)',
  [ExclusiveWorkerExpirationAction.StayAtCurrentReviewLevel]: 'Stay at the current review level',
  [ExclusiveWorkerExpirationAction.ClearResponseAndSbqToAttempt]:
    'Clear response and SBQ to attempt',
};

const ExclusiveWorkerExpirationActionBuilder: React.FC<
  ExclusiveWorkerExpirationActionBuilderProps
> = ({ name, existingValue, updateProperty, required, hint }) => {
  const options = useMemo(
    () =>
      Object.entries(labelMap).map(([id, label]) => ({
        id,
        name: label,
      })),
    [],
  );

  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex flex-row items-start gap-2">
        <SelectMenu
          className="min-w-[260px]"
          options={options}
          selectedOptionId={existingValue ?? ExclusiveWorkerExpirationAction.MoveToL11}
          setSelected={value => updateProperty(value as ExclusiveWorkerExpirationAction)}
        />
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default ExclusiveWorkerExpirationActionBuilder;
